module.exports = __webpack_public_path__ + "media/Schastye_640х1280.65348715.mp4";